const deepLinkSource = {
  DEFAULT: 0,
  WHATSAPP: 1,
  EMAIL: 2,
  CLIPBOARD: 3,
};

export default deepLinkSource;
